import { describeFields, FieldWidget } from '../common/fields';
import { LegacyExamMarkingRequestSchema } from './schemas';

export const LEGACY_EXAM_MARKING_REQUEST_FIELDS = describeFields(LegacyExamMarkingRequestSchema, {
  requestId: {},
  creationDatetime: { widget: FieldWidget.DateTime },
  dueDatetime: { widget: FieldWidget.DateTime },
  examSubject: {},
  examId: {},
  examLabel: {},
  fileName: {},
  marker: {},
  markerName: {},
  status: {},
  student: {},
  studentName: {},
});
